const React = require("react");
export const emptyFragment = ()=>React.createElement(React.Fragment);
